import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import getAuthData from '../../auth/getAuthData';

// Components
import { Card } from 'react-bootstrap';
import RepairList from '../RepairScreen/RepairList';
import BarChartDaily from './BarChartDaily';
import CustomPieChart from './CustomPieChart';
import CustomPagination from '../../components/CustomPagination';
import LoadingSpinner from '../../components/LoadingSpinner';

const DashboardScreen = (props) => {
    const [loading, setLoading] = useState(true);
    const [listLoading, setListLoading] = useState(true);
    const [weeklyRepairTotal, setWeeklyRepairTotal] = useState([]);
    const [pendingTotals, setPendingTotals] = useState([]);
    const [pendingTotal, setPendingTotal] = useState(0);
    const [repairList, setRepairList] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [page, setPage] = useState(1);

    useEffect(() => {
        const changePageHandler = async () => {
            setListLoading(true);

            const auth = getAuthData();
            let url, request;
            if (selectedStatus) {
                url = `${process.env.REACT_APP_API_URL}/repairs?f=status&s=${selectedStatus}&limit=5&page=${page}`;
            } else {

                url = `${process.env.REACT_APP_API_URL}/repairs?f=pending&limit=5&page=${page}`;
            }

            if (url) {
                request = await fetch(url, {
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${auth.token}`
                    }
                });

                if (request.status === 200) {
                    const response = await request.json();
                    setRepairList(response.list);
                    setTotalPages(response.total);
                }
            }

            setListLoading(false);
        }

        changePageHandler();
    }, [page, selectedStatus]);

    useEffect(() => {
        const getSummary = async () => {
            const auth = getAuthData();
            const url = `${process.env.REACT_APP_API_URL}/repairs/summary`;

            const request = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${auth.token}`
                }
            });

            if (request.status === 200) {
                const response = await request.json();
                setWeeklyRepairTotal(response.weekly_total);
                setPendingTotals(response.pendingTotal);
                setTotalPages(Math.ceil(response.pendingTotalNum / 5));
                setPendingTotal(response.pendingTotalNum);
                setRepairList(response.repairList);
            }

            setLoading(false);
        }

        getSummary();
    }, []);

    const changeStatusHandler = (status) => {
        setPage(1);
        setSelectedStatus(status);
    };

    return (
        <section className={styles.DashboardScreen}>
            <h4>Dashboard</h4>
            <Card className={styles.visitChartCard}>
                <Card.Header className={styles.CardTitle}>Resumen de Reparación</Card.Header>
                <Card.Body className={styles.BarChartContainer}>
                    {loading ? <LoadingSpinner className={styles.LoadingSpinner} size="lg" variant="primary" /> : <BarChartDaily data={weeklyRepairTotal} />}
                </Card.Body>
            </Card>
            <div className={styles.Row}>
                <Card className={styles.CardItem}>
                    <Card.Header className={styles.CardTitle}>Total de Reparaciónes Pendientes ({pendingTotal})</Card.Header>
                    <Card.Body className={styles.PieChartContainer}>
                        {loading ?
                            <LoadingSpinner className={styles.LoadingSpinner} size="lg" variant="primary" />
                            : pendingTotal !== 0 ? <CustomPieChart
                                data={pendingTotals}
                                onClick={changeStatusHandler} /> :
                                <text>No hay reparaciónes pendientes.</text>
                        }
                    </Card.Body>
                </Card>
                <Card className={styles.CardItem}>
                    <Card.Header className={styles.CardTitle}>Reparaciónes Pendientes</Card.Header>
                    <Card.Body className={styles.PendingListContainer}>
                        {(loading || listLoading) ? <LoadingSpinner className={styles.LoadingSpinner} size="lg" variant="primary" /> : <>
                            <RepairList className={styles.RepairList} repairs={repairList} minimal />
                            <CustomPagination
                                total={totalPages}
                                current={page}
                                limit={5}
                                setPage={setPage}
                                className={styles.PendingPagination} />
                        </>}
                    </Card.Body>
                </Card>
            </div>
        </section>
    );
};

export default DashboardScreen;